import React, { useEffect, useState, useRef } from "react";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import queryString from "query-string";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { useQuery } from "@apollo/client";
import { ADDRESS_TARIFFS_INFO_QUERY_V3, TARIFFS_HOUSE_QUERY_V5 } from "Services/queries";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import { variablesFromRouter } from "Services/QueryBuilder";
import Routes from "Configs/routes";
import ABTetsWrapperNewViewTariffs from "Containers/ABTests/ABTetsWrapperNewViewTariffs";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";
import Button from "ComponentsUI/Button";
import FilterProviders from "./FilterProviders";
import TarifficationsContainer from "./TarifficationsContainer";
import SortContainer from "./SortContainer";
import configRouters from "Configs/routes";
import { addLogsData } from "Utils/orders";
import ApplicationModel from "stores/ApplicationModel";

let v4 = require("uuid/v4");

const LIMIT = 15;

const useStyles = createUseStyles((theme) => ({
	buttonSet: {
		justifyContent: "flex-start",
		marginBottom: "50px",
	},
	headerSet: {
		alignItems: "center",
		marginBottom: "15px",
	},
	header: {
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		textTransform: "uppercase",
		color: theme.palette.colors.darkSlateBlue2,
		letterSpacing: "2.2px",
		marginRight: "15px",
	},
	block: {
		display: "block",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		buttonSet: {
			marginBottom: "20px",
		},
	},
}));

const PageWithQuery = (props) => {
	const [flat, setFlat] = useState(true);
	const {
		ApplicationModel: {
			commonViewModel,
			providerModel,
			searcheModelOneString,
			searcheModel,
			tariffsModel,
			siteConfig,
			sendingStore,
		},
		ApplicationModel,
		house_id,
		seoBlock,
		match,
	} = props;
	const classes = useStyles();

	let buttonTagRef = useRef(null);
	useEffect(() => {
		if (buttonTagRef?.current) {
			tariffsModel.setButtonTagRef(buttonTagRef.current);
		}
		return () => {
			if (buttonTagRef?.current) {
				tariffsModel.setButtonTagRef(null);
			}
		};
	}, [buttonTagRef.current]);

	const one_string_search = siteConfig?.settings?.one_string_search?.enabled;

	const setOrientation = (value) => {
		setFlat(value);
	};

	const onFilter = (filter) => {
		const {
			location: { search },
			match,
			history,
		} = props;

		let getParams = queryString.parse(search);
		let urlArr = [];
		let activeFilter = filter.url;

		if (!!activeFilter) {
			getParams.filter = activeFilter;
		} else {
			delete getParams.filter;
		}

		for (let key in getParams) {
			if (getParams[key]) {
				urlArr.push(`${key}=${getParams[key]}`);
			}
		}

		const ratesUrl = props.new_house_url
			? generateUrl(Routes.RatesInHouse.route, {
					regionUrl: match.params.regionUrl,
					house_url: match.params.house_url,
					house_id: house_id,
				})
			: generateUrl(Routes.DomaNzl.route, {
					regionUrl: match.params.regionUrl,
				});

		history.push({
			pathname: ratesUrl,
			search: `?${urlArr.join("&")}`,
		});
	};

	const addressTariffQuery = useQuery(ADDRESS_TARIFFS_INFO_QUERY_V3, {
		skip: !house_id,
		variables: { address_id: +house_id },
	});

	const addressTariffInfo = addressTariffQuery?.data?.addressTariffsInfoV3;

	let page = 1;
	if (props.match.params.page) {
		page = +props.match.params.page;
	}
	let filters;
	let tParams = queryString.parse(props.location.search);
	switch (tParams.filter) {
		case "domashniy-internet":
			filters = ["internet.speed_in=$exists&tv=!exists&mobile_new=!exists"];
			break;
		case "internetAndTV":
			filters = ["internet.speed_in=$exists&tv=$exists&mobile_new=!exists"];
			break;
		case "onlyTV":
			filters = ["tv=$exists&internet=!exists"];
			break;
		case "bezlimitniy-intenet":
			filters = ["internet.speed_in=$exists"];
			break;
		case "mobile":
			filters = ["mobile_new.sms=$exists&mobile_new.calls=$exists"];
			break;
		case "all":
			filters = [""];
			break;
		default:
			filters = ["internet.speed_in=$exists&tv=!exists&mobile_new=!exists"];
	}
	if (tParams.filter === "all" || !tParams.filter) {
		if (tParams.providers) {
			if (tParams.providers.length === 1) {
				filters = [`provider.id=0${tParams.providers}`];
			} else {
				filters = [`provider.id=${tParams.providers}`];
			}
		}
	} else if (tParams.providers) {
		if (tParams.providers.length === 1) {
			filters.push(`provider.id=0${tParams.providers}`);
		} else {
			filters.push(`provider.id=0${tParams.providers}`);
		}
	}

	const tariffsQuery = useQuery(TARIFFS_HOUSE_QUERY_V5, {
		skip: !house_id,
		variables: {
			...props.variables,
			houseId: +house_id,
			filter: filters.join("&"),
			limit: LIMIT,
			offset: page * LIMIT - LIMIT,
			providerJoin: true,
		},
	});
	const tariffs = tariffsQuery?.data?.tariffsByHouseV5?.data;
	const tariffsLoading = tariffsQuery?.loading;
	const tariffsPagination = tariffsQuery?.data?.tariffsByHouseV5?.pagination;

	useEffect(() => {
		if (
			props.withQuiz &&
			!!addressTariffInfo &&
			(commonViewModel.showModalOnRates || siteConfig.settings.show_quiz_with_direct_transition)
		) {
			props?.openFirstPopup({
				cnt_tariffs: addressTariffInfo.cnt_tariffs,
				min_price: addressTariffInfo.price.min,
				max_speed: addressTariffInfo.speed.max,
			});
		}
	}, [addressTariffInfo]);

	useEffect(() => {
		if (house_id) {
			if (one_string_search) {
				searcheModelOneString.findAddress(house_id);
			} else {
				searcheModel.findAddress(house_id);
			}
		}

		const dataLogs = {
			path: commonViewModel.nameModalOnRates,
			type: configRouters.RatesInHouse.route === match.path ? "popular" : "doma-nzl",
		};

		addLogsData(dataLogs, ApplicationModel);
		sendingStore.sendClientPortrait(dataLogs);

		return () => {
			providerModel.setProviderIdForOrder(null);
		};
	}, []);

	let params = queryString.parse(props.location.search);
	let tariffsTags = [
		{
			name: "Интернет+ТВ",
			url: "internetAndTV",
		},
		{
			name: "Только тв",
			url: "onlyTV",
		},
		{
			name: "Безлимит",
			url: "bezlimitniy-intenet",
		},
		{
			name: "+мобильная связь",
			url: "mobile",
		},
	];
	let tagDomInt = {
		name: "Домашний интернет",
		url: "domashniy-internet",
	};

	let tagForAll = {
		url: "all",
	};

	let providerFilter = (
		<FilterProviders
			centering={true}
			setOrientation={(value) => setOrientation(value)}
			flat={flat}
			house_id={house_id}
			new_house_url={props.new_house_url}
		/>
	);

	return (
		<>
			<Row className={classNames(classes.buttonSet, classes.block)}>
				<Container>
					<Button
						buttonRef={buttonTagRef}
						key={v4()}
						onClick={() => {
							onFilter(tagForAll);
						}}
						size="extraLow"
						status={params.filter === tagForAll.url ? "purple" : "tertiaryAccent"}
					>
						все
					</Button>
					<Button
						buttonRef={buttonTagRef}
						key={v4()}
						onClick={() => {
							onFilter(tagDomInt);
						}}
						size="extraLow"
						status={!params.filter || params.filter === tagDomInt.url ? "purple" : "tertiaryAccent"}
					>
						{tagDomInt.name}
					</Button>
					{tariffsTags.map((tag) => (
						<Button
							key={v4()}
							onClick={() => {
								onFilter(tag);
							}}
							size="extraLow"
							status={params.filter === tag.url ? "purple" : "tertiaryAccent"}
						>
							{tag.name}
						</Button>
					))}
				</Container>
			</Row>
			<Container>
				<HeaderTextSeo header={seoBlock?.seoHeader} text={seoBlock?.seoText} />
			</Container>
			<SortContainer
				setOrientation={(value) => setOrientation(value)}
				button={providerFilter}
				new_house_url={props.new_house_url}
			/>
			<ABTetsWrapperNewViewTariffs
				testName="testtest__new_tariff"
				tariffs={tariffs}
				pagination={tariffsPagination}
				new_house_url={props.new_house_url}
				defaultContainer={
					<TarifficationsContainer
						tariffs={tariffs}
						isLoading={tariffsLoading}
						pagination={tariffsPagination}
						useYandexEvent={true}
						isTS={true}
						addFormOneClick={true}
						new_house_url={props.new_house_url}
					/>
				}
			/>
		</>
	);
};

export default withRouter(
	withDefaultParams(
		variablesFromRouter(inject("ApplicationModel")(observer(PageWithQuery)), "popular")
	)
);
